var exports = {
  "E": "xaee3c4fa--46fb58--suggests",
  "Z": "xaee3c4fa--46fb58--suggest",
};

module.exports = exports;
